import { useScreenSize } from "./useScreenSize"

/**
 * Custom React hook to calculate spacing between chart labels based on screen size and number of elements
 *
 * This hook applies a decreasing exponential formula to determine
 * the optimal spacing between labels based on their number (n) and current screen dimensions.
 * As the number of elements in the chart increases, the spacing is reduced
 * to maintain proper readability.
 *
 * @param {number} n - Number of elements (datasets) in the chart
 * @returns {number} - Calculated spacing value (in pixels)
 */
export const useDeltaCalculation = (n) => {
  const { width, height } = useScreenSize()

  const surface = width * height
  const offset = 2.71e-6 * surface - 2.343
  return 35 * Math.pow(0.55, n - 1) + offset
}
